



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllPendingPlansWithCreator
// GETALLPENDINGPLANSWITHCREATOR


const GETALLPENDINGPLANSWITHCREATOR= createAsyncThunk(
  "getAllPendingPlansWithCreator/getAllPendingPlansWithCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPendingPlansWithCreatorSlice = createSlice({
  name: "getAllPendingPlansWithCreatorSlice",
  initialState: {
    getAllPendingPlansWithCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPendingPlansWithCreator: (state) => {
        state.getAllPendingPlansWithCreator.loading = false
        state.getAllPendingPlansWithCreator.error = false
        state.getAllPendingPlansWithCreator.data = []
        state.getAllPendingPlansWithCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPENDINGPLANSWITHCREATOR.fulfilled, (state, action) => {
      state.getAllPendingPlansWithCreator = {
        ...state.getAllPendingPlansWithCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGPLANSWITHCREATOR.pending, (state, action) => {
      state.getAllPendingPlansWithCreator = {
        ...state.getAllPendingPlansWithCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGPLANSWITHCREATOR.rejected, (state, action) => {
      state.getAllPendingPlansWithCreator = {
        ...state.getAllPendingPlansWithCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPendingPlansWithCreatorAction = {
    GETALLPENDINGPLANSWITHCREATOR,
};

export { getAllPendingPlansWithCreatorAction };
export default getAllPendingPlansWithCreatorSlice.reducer;
export const {setInitialStateOfgetAllPendingPlansWithCreator} = getAllPendingPlansWithCreatorSlice.actions
